<template>
  <div>
    <div ref="result"></div>
    <div class="tr-thankyou-wrap">
      <section class="tr-thankyou-heading">
        <h3>Catering Order Received</h3>
        <h2>Thank You!</h2>
      </section>
      <section class="tr-thankyou-location">
        <div class="tr-thankyou-description">
          <p>Thank you for your catering order. We will contact you as soon as possible regarding your order.</p>
        </div>
      </section>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    order_id: {
      type: String
    }
  },
  computed: {
  },
  data () {
    return {
      offer: null
    }
  },
  mounted () {
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style lang="scss">
.tr-thankyou-wrap {
  section {
    margin-bottom: 20px;
  }

  padding: 20px;
  max-width: 768px;
  width: 100%;
  margin: 0 auto;
}

.tr-thankyou-location {
  border: 1px solid #ccc;
}

.tr-thankyou-map {
  img {
    margin: 0;
    padding: 0;
    max-width: 100%;
    display: block;
  }

  border-bottom: 1px solid #ccc;
}

.tr-thankyou-heading {
  h3 {
    margin-bottom: 15px;
  }
}

.tr-thankyou-description {
  h3 {
    margin-bottom: 15px;
  }

  padding: 20px;
}

.tr-thankyou-customer-info {
  h3 {
    margin-bottom: 15px;
  }

  border: 1px solid #ccc;
  padding: 20px;
}

.tr-thankyou-flexarea {
  display: flex;
  flex-wrap: wrap;
}

.tr-thankyou-info {
  span {
    display: block;
  }

  flex: 50%;
  margin-bottom: 20px;
}

.tr-thankyou-button {
  background-color: #ff2400;
  color: #fff;
  font-weight: bold;
  padding: 10px;
  width: max-content;
  margin: 15px 0px;
  cursor: pointer;
}
</style>
